/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of Zuum Transportation Inc.
 #*
 #* Copyright Zuum 2015-2020. All Rights Reserved.
 #*
 #*===================================================================
 */

import { createAction, props } from '@ngrx/store';

import { AddOn, IUiPermissionApiItem, IUserPermissionType } from '@core/models';
import { Client, ICompany } from '@truckstop-tms/zuum-lib';

export const load = createAction('[ClientDetails:FeatureAccessibility] Load', props<{ client: Client }>());
export const loadSuccess = createAction(
  '[ClientDetails:FeatureAccessibility] Load Success',
  props<{ features: IUiPermissionApiItem[] }>()
);
export const loadFailure = createAction(
  '[ClientDetails:FeatureAccessibility] Load Failure',
  props<{ errorMessage: string }>()
);

export const loadShipperTMSPermissions = createAction(
  '[ClientDetails:FeatureAccessibility] Load Shipper TMS Permissions',
  props<{ client: Client }>()
);
export const loadShipperTMSPermissionsSuccess = createAction(
  '[ClientDetails:FeatureAccessibility] Load Shipper TMS Permissions Success',
  props<{ shipperTMSPermissions: IUiPermissionApiItem[] }>()
);
export const loadShipperTMSPermissionsFailure = createAction(
  '[ClientDetails:FeatureAccessibility] Load Shipper TMS Permissions Failure',
  props<{ errorMessage: string }>()
);

export const update = createAction(
  '[ClientDetails:FeatureAccessibility] Update',
  props<{
    client: Client;
    permissions: IUserPermissionType[];
    addOns: AddOn[];
  }>()
);
export const updateSuccess = createAction(
  '[ClientDetails:FeatureAccessibility] Update Success',
  props<{ company: ICompany }>()
);
export const updateFailed = createAction(
  '[ClientDetails:FeatureAccessibility] Update Failed',
  props<{ errorMessage: string }>()
);

export const saveCanges = createAction('[ClientDetails:FeatureAccessibility] Save Changes');
